/**
 * Created by Bart Decorte
 * Date: 09/11/2018
 * Time: 14:54
 */
const apiPrefix = 'json';

function url(endpoint = '') {
  return [esign.info.baseUrl, apiPrefix, endpoint].join('/');
}

const api = {
  users: {
    search: url('users/search'),
  },
};

const endpoints = {};

endpoints.tableColumns = (websiteId, tableId) => {
  return `websites/${websiteId}/tables/${tableId}/columns`;
};

endpoints.columns = (websiteId, tableName) => {
  return `websites/${websiteId}/db/tables/${tableName}/columns`;
};

endpoints.tableColumnSettings = (websiteId, tableId, tableColumnId) => {
  return `websites/${websiteId}/tables/${tableId}/columns/${tableColumnId}/settings`;
};

endpoints.appendTraceSegments = (segments) => {
  for (let i = 0; i < esign.info.trace.tableIds.length; i++) {
    segments.push(esign.info.trace.tableIds[i]);
    if (i < esign.info.trace.entryIds.length) {
      segments.push(esign.info.trace.entryIds[i]);
    }
  }
  return segments;
};

export default api;
export { api, apiPrefix, url, endpoints };



// WEBPACK FOOTER //
// ./resources/assets/js/utils/api.js